module.exports = __webpack_public_path__ + "img/cx_colocacao_brinco.5bb5ec99.webp";